/*
 * All the active fee available in the Event
 */

export const LOAD_EVENT_FEE = 'event-widgets/eventFee/LOAD_EVENT_FEE';
export const LOAD_EVENT_FEE_ORDER = 'event-widgets/eventFee/LOAD_EVENT_FEE_ORDER';

/*
 * Creates an action to load the event fees.
 */
export function loadEventFees(regTypeId, eventSnapshotVersion) {
  return async (dispatch, getState) => {
    const { accessToken, clients: { eventFeeClient } } = getState();
    let eventFees = await eventFeeClient.getEventFee(accessToken, regTypeId, eventSnapshotVersion);
    dispatch({ type: LOAD_EVENT_FEE, payload: { eventFees } });
  };
}

/*
 * Creates an action to save the event fees order.
 */
export function saveEventFeesOrder(eventFeesOrder) {
  return async (dispatch) => {
    if (eventFeesOrder) {
      dispatch({ type: LOAD_EVENT_FEE_ORDER, payload: { eventFeesOrder } });
    }
  };
}

export default function eventFeeReducer(state = {}, action) {
  switch (action.type) {
    case LOAD_EVENT_FEE:
      return action.payload.eventFees;
    default:
      return state;
  }
}

export function eventFeeOrderReducer(state = {}, action) {
  switch (action.type) {
    case LOAD_EVENT_FEE_ORDER:
      return action.payload.eventFeesOrder;
    default:
      return state;
  }
}
